// extracted by mini-css-extract-plugin
export var locationsContainer = "_zj-2";
export var locationsTextContainer = "_zj-1";
export var mapContainer = "_zj-0";